module.exports = __webpack_public_path__ + "img/fil_truss_head_sku.prt.f4829ca5.jpg";